(function($) {
    
    // Show hidden elements on scroll
    const invisibleSections = document.querySelectorAll('.invisible')
    
    const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting) {
                    entry.target.classList.remove('invisible')
                }
            })
        }, {rootMargin: "-50px 0px -50px 0px"}
    );
    
    invisibleSections.forEach(section => {
        observer.observe(section)
    })
    
})(jQuery);
(function($) {
    if ($('.archive-imoveis').length) {
        
        // Slider de produto
        const productList = $('.archive-imoveis .property .slider-container')
        
        productList.each(function(index, element) {
            $(this).find('.slider-wrapper').slick({
                accessibility: false,
                slidesPerView: 1,
                infinite: false,
                prevArrow: $(this).find('.prev'),
    			nextArrow: $(this).find('.next'),
    			responsive: [
    				{
    					breakpoint: 993,
    					settings: {
    					    arrows: false,
    						dots: true,
    						appendDots: $(this)
    					}
    				}
			    ]
            })
        })
    }
})(jQuery);
(function($) {
    if ($('.pagina-inicio').length) {
        
        // Slider principal
        $('.pagina-inicio .busca .slider-container').slick({
            accessibility: false,
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: false,
            draggable: false,
            fade: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            swipe: false,
            touchMove: false,
            speed: 1000,
            cssEase: 'ease-out'
        })
        
        // Slider de avaliações
        const slider = $('.avaliacoes .content-slider-container')
    		
    	if(slider) {
    		slider.find('.slider-wrapper').slick({
    		    accessibility: false,
    			slidesToShow: 3,
    			slidesToScroll: 3,
    			infinite: false,
    			prevArrow: slider.find('.prev'),
    			nextArrow: slider.find('.next'),
    			responsive: [
    				{
    					breakpoint: 993,
    					settings: {
    						slidesToShow: 2,
                			slidesToScroll: 2,
    					}
    				},
    				{
    					breakpoint: 576,
    					settings: {
    					    arrows: false,
    						slidesToShow: 1,
                			slidesToScroll: 1,
    						dots: true,
    						appendDots: slider
    					}
    				}
    			]
    		})
    	}
    }
})(jQuery);
(function($) {
    /* MENU */
    jQuery('.mobile-menu-button').on('click',function() {
        jQuery(this).toggleClass('open');
        jQuery('.mobile-menu').toggleClass('open');
        jQuery('body').toggleClass('no-scroll');
    });
    
    function closeMenuOnClick(event) {
        $('.mobile-menu-button').removeClass('open')
        $('.mobile-menu').removeClass('open')
        $('body').removeClass('no-scroll')
    }
    
    jQuery('.mobile-menu a:not([href="#"])').on('click', function(e) {
        if(window.matchMedia('(max-width: 1200px)').matches) {
            closeMenuOnClick(e)
            return
        }
    })
    
    $('.menu a[href="#"]').on('click', event => {
        event.preventDefault()
    })
    
    const mobileDropdownItems = $('.mobile-menu .menu-item-has-children')
    
    mobileDropdownItems.each(function() {
        const link = $(this).find('> a')
        const button = $(this).find('> button')
        
        button.on('click', () => {
            $(this).toggleClass('open-submenu');
        })
        
        link.on('click', event => {
            const href = link.attr('href')
            
            if(href === '#') {
                event.preventDefault()
                $(this).toggleClass('open-submenu');
            }
        })
    })

    // Ancoragem
    $(window).on('load', function() {
        if (anchor != "") {
            const targetPosition = $(anchor).offset().top - (window.innerWidth < 992 ? 9 : 5) * parseFloat(getComputedStyle(document.documentElement).fontSize);
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });
    
})(jQuery);
(function($) {
    
    class SearchBox {
        
        constructor(searchBox) {
            this.searchBox = searchBox
            this.visibleContent = this.searchBox.querySelector('.visible-content')
            this.hiddenContent = this.searchBox.querySelector('.hidden-content')
            this.showFilterButton = this.searchBox.querySelector('.filter-toggle')
            this.resetFilterButton = this.searchBox.querySelector('.reset-form')
            this.searchButton = this.searchBox.querySelector('.submit-button')
            this.searchField = this.searchBox.querySelector('[type="search"]')
            this.applyFiltersButton = this.searchBox.querySelector('.apply-filters')
            
            this._init()
        }
        
        _openFilterBox() {
            const { openedSize } = this._getBoxSize()
            
            this._allowFocusInside()
            this.searchBox.classList.add('opened')
            this.searchBox.style.height = `${openedSize}px`
        }
        
        _closeFilterBox() {
            const { closedSize } = this._getBoxSize()
            
            this._allowFocusInside(false)
            this.searchBox.classList.remove('opened')
            this.searchBox.style.height = `${closedSize}px`
        }
        
        _getBoxSize() {
            const closedSize = this.visibleContent.scrollHeight
            const openedSize = this.hiddenContent ? closedSize + this.hiddenContent.scrollHeight : closedSize
            
            return {
                openedSize,
                closedSize
            }
        }
        
        _updateBoxSize() {
            const { openedSize, closedSize } = this._getBoxSize()
            
            this.searchBox.style.height = this.searchBox.classList.contains('opened') ? `${openedSize}px` : `${closedSize}px`
        }
        
        _toggleFilterBox() {
            this.searchBox.classList.contains('opened') ? this._closeFilterBox() : this._openFilterBox()
        }
        
        _init() {
            document.addEventListener('DOMContentLoaded', () => {
                this._updateBoxSize()
                this._maskCurrencyFields()
                
                window.addEventListener('resize', () => {
                    this._updateBoxSize()
                })
                
                if(this.showFilterButton) {
                    this.showFilterButton.addEventListener('click', () => {
                        this._toggleFilterBox()
                    })
                }
                
                if(this.resetFilterButton) {
                    this.resetFilterButton.addEventListener('click', () => {
                        this._resetFields()
                    })
                }
                
                if(this.searchButton) {
                    this.searchButton.addEventListener('click', this._search.bind(this))
                }
                
                if(this.applyFiltersButton) {
                    this.applyFiltersButton.addEventListener('click', this._applyFilters.bind(this))
                }
            })
            
        }
        
        _resetFields() {
            this.searchBox.querySelectorAll('select, input, textarea')
                .forEach(field => field.value = '')
        }
        
        _allowFocusInside(allow = true) {
            const filterFields = this.hiddenContent.querySelectorAll('a[href], button, input, textarea, select, [tabindex]')
            
            filterFields.forEach(el => {
                el.setAttribute('tabindex', allow ? '0' : '-1')
            })
        }
        
        _maskCurrencyFields() {
            const currencyFields = this.searchBox.querySelectorAll('[data-currency="true"]')
            
            currencyFields.forEach(el => {
                $(el).priceFormat({
                    prefix: '',
                    centsSeparator: ',',
                    thousandsSeparator: '.'
                });
            })
        }
        
        _search( event ) {
            event.preventDefault()
            
            const searchValue = this.searchField.value;
            
            this._resetFields()
            this.searchField.value = searchValue
            
            this.searchBox.submit()
        }
        
        _applyFilters( event ) {}
    }
    
    if(document.querySelector('.search-box')) {
        const searchBoxes = document.querySelectorAll('.search-box')
        
        searchBoxes.forEach(el => { new SearchBox(el) })
    }
	
})(jQuery);
(function($) {
    
    if ($('.single-imoveis').length) {
        
        
        // Galeria de imagens
        const imageGallery = $('.single-imoveis .galeria')
        
        if(imageGallery.length) {
            
            
            // Devido a quantidade de imagens, exibe a galeria apenas quando todo o conteúdo da página for baixado
            $(window).on('load', function() {
                imageGallery.removeClass('is_loading')
            })
            
            const videoAutoplay = false
            
            imageGallery.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
                const sliderCount = imageGallery.find('.slider-count')
                
                if(sliderCount.length) {
                    let current = (currentSlide ? currentSlide : 0) + 1
                    let total = slick.slideCount
                    
                    sliderCount.text(`${current}/${total}`)
                }
            })
            
            const slider = imageGallery.find('.slider-wrapper').slick({
                accessibility: false,
                slidesPerView: 1,
                centerMode: true,
                variableWidth: true,
                speed: 500,
                infinite: false,
                draggable: true,
                accessibility: false,
                prevArrow: imageGallery.find('.prev'),
                nextArrow: imageGallery.find('.next'),
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            dots: false,
                            // appendDots: imageGallery,
                            centerMode: false,
                            variableWidth: false,
                        }
                    }
                ],
            })
            
            imageGallery.on('afterChange', function(event, slick, currentSlide) {
                const current = $(slick.$slides.get(currentSlide))
                const video = current.find('video')
                
                imageGallery.attr('data-current', currentSlide)
                
                if(video.length) {
                    imageGallery.addClass('video')
                    
                    if(videoAutoplay) {
                        video[0].muted = true
                        video[0].play()
                    }
                    
                    return
                }
                
                imageGallery.removeClass('video')
            })
            
            imageGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                const current = $(slick.$slides.get(currentSlide))
                const video = current.find('video')
                
                if(video.length) {
                    video[0].pause()
                }
            })
            
            
            $(window).on('keydown', event => {
                if(event.key == 'ArrowRight') {
                    slider.slick('slickNext')
                }
                
                if(event.key == 'ArrowLeft') {
                    slider.slick('slickPrev')
                }
            })
            
            
            // Configurações do FSLightbox
            if($('.toggle-lightbox').length) {
                $('.toggle-lightbox').on('click', () => {
                    const currentSlide = imageGallery.attr('data-current') ? Number(imageGallery.attr('data-current')) : 0
                    
                    fsLightbox.open(currentSlide);
                })
            }
            
            fsLightbox.props.exitFullscreenOnClose = true;
            fsLightbox.props.loadOnlyCurrentSource = true;
        }
        
        
        // Usuários vendo neste momento
        if($('.property-views').length) {
            
            $(() => {
                function random(min, max) {
                    return Math.floor(Math.random() * (max - min + 1) + min);
                }
                
                const pageSlug = new URL(window.location.href).pathname
                const savedActiveUsers = Number(localStorage.getItem(`usuariosAtivos[${pageSlug}]`))

                let isFirstIteration = true
                
                let activeUsers = savedActiveUsers ? savedActiveUsers : random(1, 6)
                
                localStorage.setItem(`usuariosAtivos[${pageSlug}]`, activeUsers)
                
                $('.property-views span').html(`${activeUsers} visualizando agora`);
                
                function updateViews() {
                    let variation = random(-1, 1);
                    if(activeUsers >= 6) variation = random(-1, 0);
                    if(activeUsers <= 1) variation = random(0, 1);
                    
                    activeUsers += variation
                    
                    localStorage.setItem(`usuariosAtivos[${pageSlug}]`, activeUsers)
                    
                    $('.property-views span').html(`${activeUsers} visualizando agora`);
                    
                    if(isFirstIteration) {
                        isFirstIteration = false
                        setInterval(updateViews, 30000)
                    }
                }
                
                setTimeout(updateViews, 5000)
            })
        }
    }
})(jQuery);
(function($) {
    
    class ModalSocial {
        constructor(openButton) {
            this.openButton = openButton
            this.modalContainer = document.querySelector(`[data-content="${this.openButton.dataset.target}"]`)
            this.closeButton = this.modalContainer.querySelector('.close-modal-button')
            this.linksList = this.modalContainer.querySelectorAll('ul li a')
            this.body = document.querySelector('body')
            this.pageFocusableElements = document.querySelectorAll('a[href], area[href], input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="file"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [contenteditable]')
            this.modalFocusableElements = this.modalContainer.querySelectorAll('a[href], area[href], input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="file"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [contenteditable]')
            
            this._setEvents()
        }
        
        _setEvents() {
            this.openButton.addEventListener('click', () => {
                this._openModal()
            })
            
            this.closeButton.addEventListener('click', () => {
                this._closeModal()
            })
            
            this.linksList.forEach(link => {
                link.addEventListener('click', () => {
                    this._closeModal()
                })
            })
            
            document.addEventListener('keydown', event => {
                if(event.key === 'Escape') {
                    this._closeModal()
                }
            })
        }
        
        _openModal() {
            this.pageFocusableElements.forEach(el => el.setAttribute('tabindex', '-1'))
            this.modalFocusableElements.forEach(el => el.setAttribute('tabindex', '0'))
            
            this.body.style.overflowY = 'hidden'
            this.body.style.maxHeight = '100vh'
            this.modalContainer.classList.add('show')
        }
        
        _closeModal() {
            this.pageFocusableElements.forEach(el => el.setAttribute('tabindex', '0'))
            this.modalFocusableElements.forEach(el => el.setAttribute('tabindex', '-1'))
            
            this.body.style.overflowY = 'auto'
            this.body.style.maxHeight = 'auto'
            this.modalContainer.classList.remove('show')
        }
    }
    
    const modalTriggers = document.querySelectorAll('.social-flutuante-button')
    
    modalTriggers.forEach(el => {
        if(el.tagName === 'BUTTON') {
            new ModalSocial(el)
        }
    })
    
    // Exibição do botão após aceite de LGPD
    if (modalTriggers) {
        const lgpdBar = document.querySelector('.lgpd-container')
        
        if(!lgpdBar) {
        	modalTriggers.forEach(el => el.classList.remove('invisible-button'))
        } else {
        	window.addEventListener('DestroyLGPD', () => {
        	    modalTriggers.forEach(el => el.classList.remove('invisible-button'))
        	})
        }
    }
    
})(jQuery);
(function($) {
    
    // Slider "visite também"
    const slider = $('.visite .content-slider-container')
		
	if(slider) {
		slider.find('.slider-wrapper').slick({
			accessibility: false,
			slidesToShow: 3,
			infinite: false,
			prevArrow: slider.find('.prev'),
			nextArrow: slider.find('.next'),
			infinite: false,
			responsive: [
				{
					breakpoint: 993,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 576,
					settings: {
					    arrows: false,
						slidesToShow: 1,
						dots: true,
						appendDots: slider
					}
				}
			]
		})
	}
	
})(jQuery);
(function($) {
    
    // CF7 events
	const cf7 = document.querySelectorAll('.wpcf7 form')
	
	if(cf7) {
		cf7.forEach(form => {
			form.addEventListener('submit', function() {
				this.querySelector('button[type=submit]').setAttribute('disabled', true)
			})
		
			form.addEventListener('wpcf7submit', function() {
				this.querySelector('button[type=submit]').removeAttribute('disabled')
			})
		})
	}
	
    // Mask phone input
    let phoneMaskFunction = function(val) {
    	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }
    
    $('.phone-input').mask(phoneMaskFunction, {
    	onKeyPress: function(val, e, field, options) {
    		field.mask(phoneMaskFunction.apply({}, arguments), options);
    	}
    });
    
})(jQuery);